module.exports = __webpack_public_path__ + "static/pp_poi-490dec4baaa8c7699e2da59d969a7f57.gif";